import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { NotLoggedView } from '@/features/clients/NotLoggedView'

export const Route = createFileRoute('/clients/$companyId/not-logged')({
  component: NotLoggedRoute,
})

function NotLoggedRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <NotLoggedView companyId={companyId} />
    </AdminGuard>
  )
}
